module.exports = __webpack_public_path__ + "img/castaway.e52456e0.jpg";